import "./styles/ColorPicker.scss";
import React, {useEffect} from "react";
import {ChromePicker} from "react-color";

interface ColorPickerComponentProps {
    color: string,
    changeHandler: (color: string) => void
}

function ColorPicker(props: ColorPickerComponentProps) {
    const [color, setColor] = React.useState<string>("#ffffff");
    const [showColorPicker, setShowColorPicker] = React.useState<boolean>(false);

    useEffect(() => {
        setColor(props.color);
    }, [props.color]);

    const handleChange = (color: any) => {
        setColor(color.hex);
    }

    const handleChangeComplete = (color: any) => {
        setColor(color.hex);
        props.changeHandler(color.hex);
    }

    return <div className={"color-picker-wrapper"}>
        <div className={"color-picker-swatch"} onClick={() => setShowColorPicker(!showColorPicker)}>
            <div className={"color-picker-preview"} style={{backgroundColor: color}}/>
            <div className={"color-picker-hex"}>
                {color}
            </div>
        </div>
        {showColorPicker && <div className={"color-picker-pop-over"}>
            <div className={"color-picker-cover"} onClick={() => setShowColorPicker(false)}/>
            <ChromePicker disableAlpha={true} color={color} onChange={handleChange} onChangeComplete={handleChangeComplete}/>
        </div>}
    </div>;
}

export default ColorPicker;
